var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"group border-t border-grey-300 bg-white hover:bg-grey-100 cursor-pointer transition-bg transition-100",on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }